import _ from 'lodash';
import constants from '$$helpers/constants';
import ganttViewModel from '$$ganttViewModel';

const HeaderStore = {
  namespaced: true,
  state: {
    UIConfig: {},
    publicUrlInfo: {},
    zoom: 1,
    currentRoute: {
      name: 'app',
      path: '/',
      params: {},
    },
  },
  getters: {
    UIConfig: state => state.UIConfig,
    publicUrlInfo: state => state.publicUrlInfo,
    zoom: state => state.zoom,
    currentRoute: state => state.currentRoute,
  },
  mutations: {
    setUIConfig(state, data) {
      state.UIConfig = data;
    },
    setPublicUrlInfo(state, data) {
      state.publicUrlInfo = data;
    },
    setZoom(state, zoom) {
      state.zoom = zoom;
    },
  },
  actions: {
    setUIConfig({ commit }, payload) {
      const dataForUIConfig = {
        head: {
          ui: ['publicUrlInfo', 'signUpButton', 'noBaseTitle', 'logo'],
          css: 'border_bottom',
        },
        toolbar: {
          ui: ['zoom', 'filter'],
          css: 'border_bottom',
        },
        sumHeight: 90,
      };

      if (payload.system && payload.system.filter) {
        _.remove(dataForUIConfig.toolbar.ui, el => ['filter'].includes(el));
      }

      if (payload.data.boardView) {
        if (dataForUIConfig.toolbar.ui.length === 1 && dataForUIConfig.toolbar.ui[0] === 'zoom') {
          dataForUIConfig.toolbar = null;
        } else {
          _.remove(dataForUIConfig.toolbar.ui, el => ['zoom'].includes(el));
        }
      }

      commit('setUIConfig', dataForUIConfig);
    },
    updatePublicUrlInfo({ commit }, payload) {
      let projectName = payload.data.project.name;
      const favicon = (payload.data.project.favicon && !!payload.data.project.show_favicon) ? payload.data.project.favicon : null;
      const teamLogo = payload.data.project.teamLogo;
      const sharedByName = (payload.system.user.lastName || payload.system.user.firstName) ? `${payload.system.user.lastName} ${payload.system.user.firstName}` : '';

      if (projectName && projectName.indexOf && projectName.indexOf('/templates/') === 0) {
        // for public template we transtalte the last part of path
        const projectNameParts = projectName.split('/');

        projectName = __(projectNameParts[4]);
      }

      const dataForHeader = {
        projectName,
        teamName: payload.data.project.teamName,
        sharedBy: `${__('shared_by_link_owner_title')} ${sharedByName}`,
        logo: teamLogo || favicon,
        css: teamLogo ? 'image' : 'favicon',
      };

      commit('setPublicUrlInfo', dataForHeader);
    },
    loadZoomShared({ commit }) {
      const projectConfig = ganttViewModel.getProjectConfig();

      commit('setZoom', constants.ZOOM.modeToZoomValue[projectConfig.durationData.mode]);
    },
  },

};

export default HeaderStore;
